import axios from "axios";
import { baseURL } from "./api_base";

const api = axios.create({
  baseURL: "http://localhost:8000/api",
});


const setToken = (accessToken) => {
  localStorage.setItem("token", accessToken);
};

const getAccessToken = () => localStorage.getItem("token");

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

// Interceptor para adicionar o token de acesso nas requisições
api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para lidar com a renovação do token
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
        .then((token) => {
          originalRequest.headers["Authorization"] = "Bearer " + token;
          return api(originalRequest);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const token = getAccessToken();

      return new Promise((resolve, reject) => {
        axios
          .post(
            `${baseURL}/refresh-token`,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then(({ data }) => {
            const newAccessToken = data.access_token;
            setToken(newAccessToken);
            api.defaults.headers.common["Authorization"] = "Bearer " + newAccessToken;
            originalRequest.headers["Authorization"] = "Bearer " + newAccessToken;
            processQueue(null, newAccessToken);
            resolve(api(originalRequest));
          })
          .catch((err) => {
            processQueue(err, null);
            localStorage.removeItem("token");  // Remover token inválido
            // Redirecionar para a tela de login
            window.location.href = "/login";
            reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }

    return Promise.reject(error);
  }
);

export default api;
